import { useFormUtils } from "@/app/hooks/useFormUtils";
import clsx from "clsx";
import React from "react";
import FormFieldErrors from "../../Reusable/FormFieldErrors";
import { IInput } from "../../interface";

const Input: React.FC<IInput> = ({
  fieldError,
  variant = "SOLID",
  errorMessages,
  disableFieldError,
  className,
  register,

  ...props
}) => {
  const { deduceFormFieldErrors, isFormFieldValid } = useFormUtils();

  const reducedErrorMessages = deduceFormFieldErrors(errorMessages, fieldError);

  const isValid = isFormFieldValid(reducedErrorMessages);

  const handleWheel: React.WheelEventHandler<HTMLInputElement> = (event) => {
    if (props.type === "number") {
      event.currentTarget.blur();
    }
    props.onWheel?.(event);
  };

  return (
    <div className={clsx("relative", className)}>
      <div
        className={clsx(
          "relative flex justify-start items-center w-full",
          variant === "SOLID" ? " shadow-sm rounded-md" : "",
        )}
      >
        {props?.startIcon && (
          <div className="left-0 inset-y-0 flex justify-center items-center pr-2 pl-2 pointer-events-none">
            {props?.startIcon}
          </div>
        )}
        <input
          {...register}
          {...props}
          autoComplete="false"
          autoCorrect="false"
          onWheel={handleWheel}
          className={clsx(
            variant === "SOLID"
              ? ` border-0 py-1.5 ring-1 ring-inset font-medium text-xs  focus:ring-2 focus:ring-inset disabled:bg-gray-200 disabled:text-gray-600  sm:leading-6 w-full ${props?.inputClassName}`
              : `border-none outline-none font-medium bg-transparent ring-0 shadow-none focus:border-none focus-within:border-none focus-within:outline-none focus:outline-none focus:ring-0 text-xs  py-1.5 w-full ${props?.inputClassName} `,
            isValid
              ? `text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-indigo-600 w-full font-medium`
              : `text-red-900 ring-red-300 placeholder:text-red-400 focus:ring-red-600`,
            props?.startIcon ? "rounded-r-md" : props?.endIcon ? "rounded-md" : "rounded-md",
          )}
        />
        {props?.endIcon && (
          <div className="right-0 inset-y-0 flex justify-center items-center pr-2 pl-2 text-xs pointer-events-none ">
            {props?.endIcon}
          </div>
        )}
      </div>
      {!disableFieldError && (
        <div className="left-1 absolute w-72 overflow-visible text-left">
          <FormFieldErrors errors={reducedErrorMessages} />
        </div>
      )}
    </div>
  );
};

export default Input;
